import type { JobComponent } from "@repo/design-system/lib/client-registry";
import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import ApplicationProcessIntGraduate from "~/components/job-page/application-process/application-process-int-graduate-eon";
import BenefitsIntGraduate from "~/components/job-page/benefits/benefits-int-graduate-eon";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";

export const intGraduateTemplate = createSubtemplate<SectionKey>({
  name: "intGraduate",
  trigger: (job) => {
    const validIds = [
      "230421",
      "232072",
      "232073",
      "232074",
      "232075",
      "232076",
      "232078",
      "232079",
      "232081",
      "232083",
    ];
    return validIds.includes(job.data.idClient);
  },
  showProd: true,
  config: {
    sections: [
      "stickyContact",
      "headerImage",
      "sectionBar",
      "breadcrumb",
      "companyInfo",
      "jobDescription",
      "contact",
      "applicationProcess",
      "diversity",
      "experienceReports",
      "about",
      "benefits",
      "similarJobs",
      "stickyApplyBar",
      "printView",
    ],
    sectionBarItems: [
      {
        href: "#company",
        label: "sectionBar_company",
        section: "company",
      },
      {
        href: "#job",
        label: "sectionBar_job",
        section: "job",
      },
      {
        href: "#contact",
        label: "sectionBar_contact",
        section: "contact",
      },
      {
        href: "#applicationProcess",
        label: "sectionBar_process",
        section: "applicationProcess",
      },
    ],
    overrides: {
      applicationProcess: ApplicationProcessIntGraduate as JobComponent,
      benefits: BenefitsIntGraduate as JobComponent,
    },
  },
});
